import { IsNotEmpty, IsIn, IsNumber, IsBoolean, IsOptional } from "class-validator";

import { Constants } from "@eagerdog/constants";

import { IAkcAgilityScore } from "./akc-agility-score.interface";

export class AkcAgilityScoreDto implements IAkcAgilityScore {
  //
  @IsNotEmpty()
  @IsIn(Object.values(Constants.score_result_type))
  result_type: string;

  @IsNumber()
  score?: number;

  @IsOptional()
  search_time?: string; // mm:ss:tt

  @IsOptional()
  course_time?: string; // mm:ss:tt

  @IsNumber()
  refusals?: number;

  @IsNumber()
  table_faults?: number;

  @IsNumber()
  wrong_course?: number;

  @IsBoolean()
  failed?: boolean;

  @IsBoolean()
  excusal?: boolean;

  @IsNumber()
  total_faults?: number;

  @IsBoolean()
  feo?: boolean;

  @IsBoolean()
  absent?: boolean;

  @IsOptional()
  comment?: string;
}
